(function () {
  if (window.toaMobileShopBarLoaded) return;
  window.toaMobileShopBarLoaded = true;

  var bar = null;
  var fallbackHost = null;
  var movedHost = null;
  var movedHostParent = null;
  var movedHostNext = null;
  var mutationQueued = false;
  var mq = window.matchMedia ? window.matchMedia("(max-width: 767px)") : { matches: false };
  var shopPathPattern = /^\/(collections|search)(\/|$)/;

  function isShopListPage() {
    return shopPathPattern.test(window.location.pathname || "");
  }

  function visible(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);
    return rect.width > 0 && rect.height > 0 && style.visibility !== "hidden" && style.display !== "none";
  }

  function injectStyle() {
    if (document.getElementById("toa-mobile-shop-bar-style")) return;
    var style = document.createElement("style");
    style.id = "toa-mobile-shop-bar-style";
    style.textContent = [
      "@media (max-width: 767px) {",
      "  body.toa-mobile-shop-bar-ready { padding-bottom: var(--toa-mobile-shop-bottom-space, 132px) !important; }",
      "  body.show-cart-summary .toa-mobile-shop-bar, body.show-cart .toa-mobile-shop-bar, body.cart-summary-open .toa-mobile-shop-bar { display: none !important; }",
      "  body.show-cart-summary .toa-mobile-shop-shell, html.show-cart-summary body .toa-mobile-shop-shell { z-index: 2147483647 !important; }",
      "  .toa-mobile-shop-host { overflow: visible !important; }",
      "  .toa-mobile-shop-shell { position: fixed; left: 0; right: 0; bottom: 0; z-index: 2147483400; padding-bottom: env(safe-area-inset-bottom); background: transparent; box-shadow: 0 -12px 32px rgba(24, 48, 30, .16); }",
      "  .toa-mobile-shop-shell .toa-mobile-quick-actions { position: relative !important; left: auto !important; right: auto !important; top: auto !important; bottom: auto !important; transform: none !important; margin: 0 auto 6px !important; max-width: calc(100% - 20px); }",
      "  .toa-mobile-shop-shell .toa-mobile-shop-bar { width: 100%; }",
      "  .toa-mobile-shop-bar { position: relative; z-index: 1; padding: 8px 10px 7px; background: linear-gradient(180deg, #fffaf2 0%, #f7ead0 100%); border-top: 1px solid rgba(35, 66, 42, .13); border-bottom: 1px solid rgba(202, 145, 37, .24); box-shadow: 0 -10px 26px rgba(24, 48, 30, .12); backdrop-filter: blur(12px); }",
      "  .toa-mobile-shop-bar__form { display: grid; grid-template-columns: minmax(0, 1fr) 68px 86px; gap: 7px; max-width: 640px; margin: 0 auto; align-items: center; }",
      "  .toa-mobile-shop-bar__search { display: grid; grid-template-columns: minmax(0, 1fr) 58px; min-height: 42px; border: 1px solid rgba(43, 77, 38, .23); border-radius: 999px; background: #fff; overflow: hidden; box-shadow: inset 0 0 0 1px rgba(255,255,255,.65); }",
      "  .toa-mobile-shop-bar__input { min-width: 0; width: 100%; border: 0 !important; padding: 0 0 0 13px !important; min-height: 42px; font-size: 15px !important; line-height: 1.2 !important; background: transparent !important; color: #18331f !important; box-shadow: none !important; outline: 0 !important; }",
      "  .toa-mobile-shop-bar__submit, .toa-mobile-shop-bar__filter, .toa-mobile-shop-bar__sort-toggle { display: flex; align-items: center; justify-content: center; height: 42px; min-height: 42px; border: 0; font-weight: 900; font-size: 13px; line-height: 1 !important; white-space: nowrap; cursor: pointer; text-align: center; }",
      "  .toa-mobile-shop-bar__submit { color: #fff; background: #2f5a22; border-radius: 999px; margin: 3px; height: 36px; min-height: 36px; padding: 0 8px; font-size: 12px; }",
      "  .toa-mobile-shop-bar__filter, .toa-mobile-shop-bar__sort-toggle { color: #17351e; background: #f5e6c9; border: 1px solid rgba(202, 145, 37, .45); border-radius: 14px; padding: 0 7px; box-shadow: 0 4px 12px rgba(24,48,30,.08); }",
      "  .toa-mobile-shop-bar__filter.is-active { background: #244d28; color: #fff; border-color: #244d28; }",
      "  .toa-mobile-shop-bar__sort { position: relative; min-width: 0; }",
      "  .toa-mobile-shop-bar__sort-toggle { width: 100%; }",
      "  .toa-mobile-shop-bar__sort-toggle.is-active { background: #244d28; color: #fff; border-color: #244d28; }",
      "  .toa-mobile-shop-bar__sort-menu { position: absolute; right: 0; bottom: calc(100% + 9px); width: min(286px, calc(100vw - 18px)); padding: 9px; border-radius: 18px; background: #fffaf2; border: 1px solid rgba(202,145,37,.4); box-shadow: 0 18px 42px rgba(24,48,30,.22); }",
      "  .toa-mobile-shop-bar__sort-menu[hidden] { display: none !important; }",
      "  .toa-mobile-shop-bar__sort-title { display: block; padding: 4px 8px 9px; color: #9e342d; font-size: 11px; font-weight: 950; text-transform: uppercase; letter-spacing: .04em; }",
      "  .toa-mobile-shop-bar__sort-option { display: flex; align-items: center; justify-content: space-between; width: 100%; min-height: 40px; margin: 0 0 5px; padding: 0 11px; border: 1px solid rgba(32,54,31,.1); border-radius: 12px; background: #fff; color: #17351e; font-size: 14px; font-weight: 850; text-align: left; }",
      "  .toa-mobile-shop-bar__sort-option:last-child { margin-bottom: 0; }",
      "  .toa-mobile-shop-bar__sort-option.is-active { background: #244d28; color: #fff; border-color: #244d28; }",
      "  .toa-mobile-shop-bar__toast { position: fixed; left: 12px; right: 12px; bottom: var(--toa-mobile-shop-bottom-space, 132px); z-index: 2147483401; padding: 10px 12px; border-radius: 12px; background: #244d28; color: #fff; font-size: 13px; line-height: 1.25; text-align: center; box-shadow: 0 10px 24px rgba(24,48,30,.22); opacity: 0; transform: translateY(10px); pointer-events: none; transition: opacity .18s ease, transform .18s ease; }",
      "  .toa-mobile-shop-bar__toast.is-visible { opacity: 1; transform: translateY(0); }",
      "}",
      "@media (min-width: 768px) { .toa-mobile-shop-bar, .toa-mobile-shop-bar__toast, .toa-mobile-shop-fallback-host, .toa-mobile-shop-shell { display: none !important; } body.toa-mobile-shop-bar-ready { padding-bottom: 0 !important; } }"
    ].join("\n");
    document.head.appendChild(style);
  }

  function currentQuery() {
    try {
      return new URLSearchParams(window.location.search).get("q") || "";
    } catch (error) {
      return "";
    }
  }

  var sortOptions = [
    { value: "created-descending", label: "Neu nach alt" },
    { value: "best-selling", label: "Meistverkauft" },
    { value: "price-ascending", label: "G\u00fcnstigste zuerst" },
    { value: "price-descending", label: "Teuerste zuerst" }
  ];

  function currentSort() {
    try {
      return new URLSearchParams(window.location.search).get("sort_by") || "";
    } catch (error) {
      return "";
    }
  }

  function sortOptionLabel(value) {
    var found = sortOptions.find(function (option) { return option.value === value; });
    return found ? found.label : "Sortieren";
  }

  function renderSortMenu() {
    var active = currentSort();
    return [
      '<div class="toa-mobile-shop-bar__sort">',
      '  <button class="toa-mobile-shop-bar__sort-toggle" type="button" aria-haspopup="true" aria-expanded="false">' + sortOptionLabel(active) + '</button>',
      '  <div class="toa-mobile-shop-bar__sort-menu" hidden>',
      '    <span class="toa-mobile-shop-bar__sort-title">Sortieren nach</span>',
      sortOptions.map(function (option) {
        var activeClass = option.value === active ? " is-active" : "";
        return '    <button class="toa-mobile-shop-bar__sort-option' + activeClass + '" type="button" data-sort-value="' + option.value + '">' + option.label + '</button>';
      }).join(""),
      '  </div>',
      '</div>'
    ].join("");
  }

  function closeSortMenu() {
    if (!bar) return;
    var toggle = bar.querySelector(".toa-mobile-shop-bar__sort-toggle");
    var menu = bar.querySelector(".toa-mobile-shop-bar__sort-menu");
    if (menu) menu.hidden = true;
    if (toggle) {
      toggle.classList.remove("is-active");
      toggle.setAttribute("aria-expanded", "false");
    }
  }

  function applySort(value) {
    var url;
    try {
      url = new URL(window.location.href);
    } catch (error) {
      return;
    }
    url.searchParams.set("sort_by", value);
    window.location.href = url.toString();
  }

  function showToast(message) {
    var toast = document.querySelector(".toa-mobile-shop-bar__toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "toa-mobile-shop-bar__toast";
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(toast._toaTimer);
    toast._toaTimer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 1800);
  }

  function findNativeFilterTrigger() {
    var selectors = [
      ".cc-toolbar-filter-toggle",
      "[data-toggle-filters]",
      "[data-filter-toggle]",
      "[data-filters-toggle]",
      "[data-facet-toggle]",
      ".filter-toggle",
      ".filters-toggle",
      ".facets-toggle",
      ".mobile-filter-button",
      ".cc-filters__toggle",
      ".collection-filter-toggle",
      "button[aria-controls*='filter' i]",
      "button[aria-controls*='facet' i]",
      "a[href*='filter']"
    ];
    for (var i = 0; i < selectors.length; i += 1) {
      var match = document.querySelector(selectors[i]);
      if (visible(match)) return match;
    }
    var candidates = Array.prototype.slice.call(document.querySelectorAll("button, a, summary"));
    return candidates.find(function (candidate) {
      if (isOwnElement(candidate)) return false;
      var text = (candidate.textContent || candidate.getAttribute("aria-label") || "").replace(/\s+/g, " ").trim();
      return visible(candidate) && /(^|\s)(filter|filtern|filteroptionen|verfeinern)(\s|$)/i.test(text);
    }) || null;
  }

  function scrollToFilterArea() {
    var selectors = [
      ".filters",
      ".facets",
      ".collection-sidebar",
      ".collection-filters",
      "#filter",
      "#filters",
      "[id*='filter' i]",
      "[class*='filter' i]"
    ];
    for (var i = 0; i < selectors.length; i += 1) {
      var area = document.querySelector(selectors[i]);
      if (visible(area)) {
        area.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }
    }
    return false;
  }

  function openFilters(button) {
    var trigger = findNativeFilterTrigger();
    if (trigger) {
      trigger.click();
      button.classList.add("is-active");
      window.setTimeout(function () { button.classList.remove("is-active"); }, 1000);
      return;
    }
    if (scrollToFilterArea()) {
      showToast("Filterbereich geöffnet.");
    } else {
      showToast("Auf dieser Seite gibt es keinen separaten Filter.");
    }
  }

  function isOwnElement(el) {
    return !!(el && (
      el.classList.contains("toa-mobile-shop-bar") ||
      el.classList.contains("toa-mobile-shop-fallback-host") ||
      el.closest(".toa-mobile-shop-bar") ||
      el.closest(".toa-mobile-shop-fallback-host")
    ));
  }

  function looksLikeBottomShopNav(el) {
    if (!el || isOwnElement(el) || !visible(el)) return false;
    var style = window.getComputedStyle(el);
    if (style.position !== "fixed" && style.position !== "sticky") return false;
    var rect = el.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    if (rect.width < Math.min(300, viewportWidth * 0.72)) return false;
    if (rect.height < 34 || rect.height > 190) return false;
    if (viewportHeight && Math.abs(viewportHeight - rect.bottom) > 14) return false;
    var text = (el.textContent || "").replace(/\s+/g, " ").toLowerCase();
    var controls = el.querySelectorAll("a, button").length;
    var hasShopWords = /(produkte|anfahrt|kontakt|warenkorb|start|home|filiale|konto)/i.test(text);
    return hasShopWords || controls >= 2;
  }

  function findBottomShopHost() {
    var quickActions = document.querySelector(".toa-mobile-quick-actions");
    if (quickActions && !quickActions.closest(".toa-mobile-shop-shell") && visible(quickActions)) {
      return quickActions;
    }
    var all = Array.prototype.slice.call(document.querySelectorAll("nav, footer, aside, section, div"));
    var best = null;
    var bestScore = -1;
    all.forEach(function (el) {
      if (!looksLikeBottomShopNav(el)) return;
      var text = (el.textContent || "").replace(/\s+/g, " ").toLowerCase();
      var controls = el.querySelectorAll("a, button").length;
      var rect = el.getBoundingClientRect();
      var score = Math.min(controls, 8);
      if (/(produkte|anfahrt|kontakt|warenkorb|filiale)/i.test(text)) score += 20;
      if (rect.height > 46) score += 2;
      if (score > bestScore) {
        best = el;
        bestScore = score;
      }
    });
    while (best && best.parentElement && best.parentElement !== document.body && looksLikeBottomShopNav(best.parentElement)) {
      best = best.parentElement;
    }
    return best;
  }

  function ensureFallbackHost() {
    if (fallbackHost && document.body.contains(fallbackHost)) return fallbackHost;
    fallbackHost = document.querySelector(".toa-mobile-shop-fallback-host");
    if (fallbackHost) fallbackHost.classList.add("toa-mobile-shop-shell");
    if (!fallbackHost) {
      fallbackHost = document.createElement("div");
      fallbackHost.className = "toa-mobile-shop-fallback-host toa-mobile-shop-shell";
      document.body.appendChild(fallbackHost);
    }
    return fallbackHost;
  }

  function syncBottomSpace(host) {
    window.setTimeout(function () {
      var target = host || (bar && bar.parentElement);
      if (!target || !visible(target)) return;
      var rect = target.getBoundingClientRect();
      var value = Math.max(104, Math.ceil(rect.height + 8));
      document.documentElement.style.setProperty("--toa-mobile-shop-bottom-space", value + "px");
    }, 40);
  }

  function placeBar() {
    if (!bar) return null;
    var shell = ensureFallbackHost();
    if (bar.parentElement !== shell || shell.firstElementChild !== bar) {
      shell.insertBefore(bar, shell.firstChild);
    }
    var host = movedHost || findBottomShopHost();
    if (host && host !== shell && !shell.contains(host)) {
      movedHost = host;
      movedHostParent = host.parentNode;
      movedHostNext = host.nextSibling;
      host.classList.add("toa-mobile-shop-host");
      shell.appendChild(host);
    }
    syncBottomSpace(shell);
    return shell;
  }

  function removeBar() {
    if (bar) bar.remove();
    bar = null;
    if (movedHost && movedHostParent) {
      movedHost.classList.remove("toa-mobile-shop-host");
      movedHostParent.insertBefore(
        movedHost,
        movedHostNext && movedHostNext.parentNode === movedHostParent ? movedHostNext : null
      );
    }
    movedHost = null;
    movedHostParent = null;
    movedHostNext = null;
    if (fallbackHost && fallbackHost.parentElement) fallbackHost.remove();
    fallbackHost = null;
    document.body.classList.remove("toa-mobile-shop-bar-ready");
    document.documentElement.style.removeProperty("--toa-mobile-shop-bottom-space");
  }

  function buildBar() {
    injectStyle();
    if (!mq.matches || !isShopListPage()) {
      removeBar();
      return;
    }
    if (bar && document.documentElement.contains(bar)) {
      var existingInput = bar.querySelector(".toa-mobile-shop-bar__input");
      if (existingInput && !existingInput.matches(":focus")) existingInput.value = currentQuery();
      document.body.classList.add("toa-mobile-shop-bar-ready");
      placeBar();
      return;
    }
    bar = document.createElement("div");
    bar.className = "toa-mobile-shop-bar";
    bar.setAttribute("role", "search");
    bar.innerHTML = [
      '<form class="toa-mobile-shop-bar__form" action="/search" method="get">',
      '  <div class="toa-mobile-shop-bar__search">',
      '    <input type="hidden" name="type" value="product">',
      '    <input class="toa-mobile-shop-bar__input" type="search" name="q" autocomplete="off" placeholder="Produkt suchen" aria-label="Produkt suchen">',
      '    <button class="toa-mobile-shop-bar__submit" type="submit">Suchen</button>',
      '  </div>',
      '  <button class="toa-mobile-shop-bar__filter" type="button" aria-label="Filter öffnen">Filter</button>',
      renderSortMenu(),
      '</form>'
    ].join("");
    document.body.classList.add("toa-mobile-shop-bar-ready");
    placeBar();
    var input = bar.querySelector(".toa-mobile-shop-bar__input");
    var form = bar.querySelector("form");
    var filterButton = bar.querySelector(".toa-mobile-shop-bar__filter");
    var sortToggle = bar.querySelector(".toa-mobile-shop-bar__sort-toggle");
    var sortMenu = bar.querySelector(".toa-mobile-shop-bar__sort-menu");
    if (input) input.value = currentQuery();
    if (filterButton) {
      filterButton.addEventListener("click", function () {
        openFilters(filterButton);
      });
    }
    if (form) {
      form.addEventListener("submit", function (event) {
        if (!input || !input.value.trim()) {
          event.preventDefault();
          if (input) input.focus();
          showToast("Suchbegriff eingeben.");
        }
      });
    }
    if (sortToggle && sortMenu) {
      sortToggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = sortMenu.hidden;
        sortMenu.hidden = !willOpen;
        sortToggle.classList.toggle("is-active", willOpen);
        sortToggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
      });
      sortMenu.addEventListener("click", function (event) {
        var option = event.target && event.target.closest ? event.target.closest(".toa-mobile-shop-bar__sort-option") : null;
        if (!option) return;
        event.preventDefault();
        applySort(option.getAttribute("data-sort-value") || "");
      });
    }
  }

  function scheduleBuild() {
    if (mutationQueued) return;
    mutationQueued = true;
    window.setTimeout(function () {
      mutationQueued = false;
      buildBar();
    }, 120);
  }

  document.addEventListener("DOMContentLoaded", buildBar);
  document.addEventListener("click", function (event) {
    if (!bar || !bar.contains(event.target)) closeSortMenu();
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeSortMenu();
  });
  window.addEventListener("pageshow", buildBar);
  window.addEventListener("resize", buildBar);
  window.addEventListener("orientationchange", buildBar);
  if (window.MutationObserver) {
    new MutationObserver(scheduleBuild).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.setTimeout(buildBar, 300);
  window.setTimeout(buildBar, 1100);
})();
